import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useAuth } from './useAuth';
import { useStations } from './useStations';
import { useToast } from '@/hooks/use-toast';

export function useStationAccess(stationId: string | undefined) {
  const { user } = useAuth();
  const { data: stations } = useStations();
  const [, navigate] = useLocation();
  const { toast } = useToast();
  
  useEffect(() => {
    if (!stationId || !stations || !user) return;
    
    // Admin users have access to all stations
    if (user.role === 'admin') return;
    
    // Check if the station exists in the user's available stations
    const hasAccess = stations.some(station => station.id === stationId);
    
    if (!hasAccess) {
      toast({
        title: "Access Denied",
        description: "You do not have permission to access this station",
        variant: "destructive",
      });
      
      // Redirect to the first available station, or dashboard if none
      if (stations.length > 0) {
        navigate(`/stations/${stations[0].id}`);
      } else {
        navigate('/');
      }
    }
  }, [stationId, stations, user, navigate, toast]);
  
  // Return whether the user has access
  const hasAccess = !stationId || !stations || !user || 
    user.role === 'admin' || 
    stations.some(station => station.id === stationId);
  
  return { hasAccess };
}